(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pair-with"] && !window.DesignMode) return;
  try {
    
  class ProductComplementary extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-complementary');
            if(recommendations && recommendations.innerHTML.trim().length){
              this.innerHTML = recommendations.innerHTML;
            }
            if(html.querySelector('.grid__item')){
              this.classList.add('product-recommendations--loaded');
            }
            if(document.querySelector('.complementary-product-slider') == null){
              document.querySelector('.section-pair-with').style.display = 'none';
            }
            var init = false;
            var swiper;
            function swiperCard(){
              if(window.innerWidth <= 991){
                if(!init){
                  init = true;
                  swiper = new Swiper(".complementary-product-slider",{
                    loop: false,
                    slidesPerView: "auto",
                    a11y: false,
                    pagination:{
                      el:".complementary-product .swiper-pagination",
                      clickable: true
                    },
                  });
                }
              }else if(init){
                swiper.destroy();
                init = false;
              }
            }
            swiperCard();
            window.addEventListener("resize", swiperCard);
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-complementary', ProductComplementary);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if(recommendations && recommendations.innerHTML.trim().length){
            this.innerHTML = recommendations.innerHTML;
          }
          if(html.querySelector('.grid__item')){
            this.classList.add('product-recommendations--loaded');
          }
          document.querySelectorAll('.product-carousel').forEach(function(Element,index){
            let productid = Element.dataset.id;
            let outer_carousel = Element.closest('.related-products');
            let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
            let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
            let paginate = outer_carousel.querySelectorAll('.swiper-pagination')[0];
            let swiper = new Swiper(Element,{
              loop:eval(Element.dataset.loop),
              slidesPerView: "auto",
              slidesPerGroup: 2,
              navigation: {
                nextEl:nextbutton,
                prevEl:prevbutton,
              },
              pagination: {
                el: paginate,
                clickable: true
              },
              a11y: false,
              breakpoints: {
               768: {
                  slidesPerGroup: 1,
                },
              }
            })
            if(document.querySelectorAll('.related-tab li')){
              document.querySelectorAll('.related-tab li').forEach((tab) =>{
                let currentVal = tab.getAttribute('data-title');
                if(Element.closest('.carousel-rowouter').getAttribute('data-title') == currentVal){
                  tab.addEventListener('click',function(e){
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    let tabsWithIsOpen = document.querySelectorAll(".related-tab li.active-tab");
                    tabsWithIsOpen.forEach((tabWithIsOpen) => {
                      tabWithIsOpen.classList.remove("active-tab");
                    });
                    tab.classList.add("active-tab");
                    let currentCarousel = Element.closest('.carousel-rowouter').getAttribute('data-title');
                    if(currentVal == currentCarousel){
                      let carouselsWithIsOpen = document.querySelectorAll(".carousel-rowouter.active-carousel");
                      carouselsWithIsOpen.forEach((carouselWithIsOpen) => {
                        carouselWithIsOpen.classList.remove("active-carousel");
                      });
                      Element.closest('.carousel-rowouter').classList.add("active-carousel");
                    }
                    swiper.update();
                  });
                }
              });
            }
          });
        })
        .catch(e => {console.error(e);});
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
